const isReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
if (isReduced) {
  const heroVideo = document.querySelector(".wp-block-pulp-hero video");
  if (heroVideo) {
    heroVideo.pause();
  }
}

/*
Imports
*/
import "./app/animations.js";
import "./app/site-header.js";
import "./app/tabbed-content.js";
import "./app/statistics.js";
import "./app/team-members.js";
import "./app/resources-landing.js";
import "./app/split-content-card.js";
import "./app/two-column-story-cards.js";
import "./app/pledge-counter.js";
